import React, { useContext } from 'react';
import { useMediaQuery } from '@mui/material';
import { MobileDateFilter } from '../MobileDateFilter/MobileDateFilter';
import { CommonFilterFields } from 'constants/filters/commonFilterFields';
import DateTimeRangePicker from 'components/molecule/DateTimeRangePicker/DateTimeRangePicker';
import { FilterFormCtx } from '../filterFormCtx';

const START_KEY = CommonFilterFields.START_DATE.key;
const END_KEY = CommonFilterFields.END_DATE.key;

export function DateRangeFilter() {
  const { control, watch, onSubmit, onReset } = useContext(FilterFormCtx);
  const isTablet = useMediaQuery('(max-width: 1280px)');

  if (isTablet) {
    return (
      <>
        <MobileDateFilter
          control={control}
          name={START_KEY}
          onSubmit={onSubmit}
          onReset={onReset}
        />
        <MobileDateFilter
          control={control}
          name={END_KEY}
          startEndOfDay='end'
          onSubmit={onSubmit}
          onReset={onReset}
        />
      </>
    );
  }

  return (
    <DateTimeRangePicker
      control={control}
      watch={watch}
    />
  );
}
